<template>
    <div class="order-summary__product">
        <div class="order-summary__product__image-container">
            <img class="order-summary__product__image" :src="item.image" />
        </div>
        <div>
            <p class="order-summary__paragraph text-left" v-text="item.name"></p>
            <p class="pre-order" v-if="!isThisWeek && item.available_from" v-text="preOrderText"></p>
            <p class="order-summary__detail text-left mt-2" v-text="`${item.quantity} x ${currency}${item.price}`"></p>
            <button v-if="allowChange" class="order-summary__detail text-left mt-1 underline block" @click="removeFromOrder">{{$t('SHOP_THUMBNAIL_REMOVE')}}</button>
        </div>
    </div>
</template>

<script>
import format from 'date-fns/format';
import ErrorResponseHandler from '@/helpers/ErrorResponseHandler';
import ShopService from '@/services/shop/ShopService.js';
import { CSPageEvents } from '@/helpers/GAHelpers';

let shopService = new ShopService();

export default {
    name: 'ThumbnailProduct',
    data() {
        return {
            errorHandler: new ErrorResponseHandler(),
        };
    },
    props: {
        item: {
            required: true,
            type: Object,
        },
        currency: {
            required: true,
            type: String,
        },
        activeSubscription: {
            required: true,
            type: Object,
        },
        allowChange: {
            required: true,
            type: Boolean,
        },
        isThisWeek: {
            required: true,
            type: Boolean,
        },
    },
    computed: {
        preOrderText() {
            let date = new Date(this.item.available_from);
            return `${this.$t('SHOP_THUMBNAIL_PRE_ORDER', { date: format(date, 'do MMM') })}`;
        },
    },
    methods: {
        removeFromOrder() {
            shopService.removeFromOrder(this.activeSubscription.id, this.item.id)
                .then(() => {
                    CSPageEvents('productRemoved', {
                        productName: this.item.name,
                        productId: this.item.id,
                        productPrice: this.item.price,
                    });
                    this.$store.dispatch('shop/fetchOrderSummary', true);
                })
                .catch(error => {
                    setTimeout(() => this.errorHandler.setResponse(error.response?.data), 0);
                });
        },
    },

};
</script>

<style lang="scss" scoped>
.pre-order {
    font-size: 16px;
    font-weight: 400;
    text-align: center;
}
</style>
